<template>
    <svg :class="design" :width="width" :height="height" viewBox="0 0 16 18" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 14.7656C7.60714 14.7656 7.28571 14.4492 7.28571 14.0625V11.8125C7.28571 11.4258 7.60714 11.1094 8 11.1094C8.39286 11.1094 8.71429 11.4258 8.71429 11.8125V14.0625C8.71429 14.4492 8.39286 14.7656 8 14.7656ZM16 9.56252V16.3125C16 17.2441 15.2321 18 14.2857 18H1.71429C0.767857 18 0 17.2441 0 16.3125V9.56252C0 8.63088 0.767857 7.87502 1.71429 7.87502H2.28571V5.62502C2.28571 2.51722 4.85714 -0.010514 8.01786 3.28852e-05C11.175 0.0105797 13.7143 2.56995 13.7143 5.67776V7.87502H14.2857C15.2321 7.87502 16 8.63088 16 9.56252ZM3.42857 7.87502H12.5714V5.62502C12.5714 3.143 10.5214 1.12503 8 1.12503C5.47857 1.12503 3.42857 3.143 3.42857 5.62502V7.87502ZM14.8571 16.3125V9.56252C14.8571 9.25314 14.6 9.00002 14.2857 9.00002H1.71429C1.4 9.00002 1.14286 9.25314 1.14286 9.56252V16.3125C1.14286 16.6219 1.4 16.875 1.71429 16.875H14.2857C14.6 16.875 14.8571 16.6219 14.8571 16.3125Z"
            :fill="fill" />
    </svg>
</template>
<script>
export default {
    name: 'ui-lock-icon',
    props: {
        design: {
            type: String,
            default: ''
        },
        fill: {
            type: String,
            default: '#FFF'
        },
        width: {
            type: [String, Number],
            default: 16
        },
        height: {
            type: [String, Number],
            default: 18
        }
    }
}
</script>